import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const ServiceCard = ({ icon, title, description }) => (
  <motion.div 
    whileHover={{ y: -8 }}
    className="bg-zinc-950 p-8 rounded-2xl border border-zinc-800 hover:border-yellow-400 transition-all group"
  >
    <div className="bg-zinc-900 p-4 rounded-xl w-fit mb-6 group-hover:bg-yellow-400 transition-colors">
      <SafeIcon icon={icon} className="h-6 w-6 text-yellow-400 group-hover:text-black" />
    </div>
    <h3 className="text-2xl font-bold mb-3 uppercase tracking-tight">{title}</h3>
    <p className="text-zinc-500 leading-relaxed font-medium text-sm">{description}</p>
  </motion.div>
);

export default ServiceCard;